export const toggleOptions = { true: "Yes", false: "No" };
